<template>
  <b-card title="Supplier Return Matrix">
    <supplier-return-matrix-filters
      @filtersUpdated="filtersChangeHandler"
    />
    <supplier-return-matrix-table
      :filters="filters"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SupplierReturnMatrixFilters from '@/components/SupplierReturn/SupplierReturnMatrixFilters.vue'
import SupplierReturnMatrixTable from '@/components/SupplierReturn/SupplierReturnMatrixTable.vue'

export default {
  components: {
    BCard,
    SupplierReturnMatrixFilters,
    SupplierReturnMatrixTable,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}
</script>
